module.exports = __webpack_public_path__ + "31dee064d0967cdeb61b75500dc60b80.pdf";